import OliverText from "@builder/components/general/OliverText";
import TooltipElement from "../Tooltip";
import "./style.scss";

interface RadioInputBaseProps<T> {
    options: T[];
    isChecked: (option: T) => boolean;
    title?: string;
    callback: (option: T) => void;
    noTranslate?: boolean;
    getTooltip?: (option: T) => string;
}

interface RadioInputWithLabels<T> extends RadioInputBaseProps<T> {
    getLabel: (option: T) => string;
}

interface RadioInputWithImages<T> extends RadioInputBaseProps<T> {
    getSrc: (option: T) => string;
}

const RadioInputAlt = <T,>(props: RadioInputWithImages<T> | RadioInputWithLabels<T>) => {
    const { options, isChecked, title, callback, getTooltip } = props;

    return (
        <div className="radio-input-wrapper">
            {title && <OliverText size="xs" text={title} />}
            <div className="radio-group">
                {options.map((option, index) => {
                    if (getTooltip && getTooltip(option)) {
                        return (
                            <TooltipElement key={index} text={getTooltip(option)}>
                                <label>
                                    <input type="radio" checked={isChecked(option)} onChange={() => callback(option)} />
                                    <div className="custom-radio">
                                        {"getLabel" in props && <p>{props.getLabel(option)}</p>}
                                        {"getSrc" in props && <img src={props.getSrc(option)} />}
                                    </div>
                                </label>
                            </TooltipElement>
                        );
                    } else {
                        return (
                            <label key={index}>
                                <input type="radio" checked={isChecked(option)} onChange={() => callback(option)} />
                                <div className="custom-radio">
                                    {"getLabel" in props && <p>{props.getLabel(option)}</p>}
                                    {"getSrc" in props && <img src={props.getSrc(option)} />}
                                </div>
                            </label>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default RadioInputAlt;
